<template>
  <div class="mall-index">
    <div class="scale-container">
      <!-- 轮播 -->
      <div class="mall-swiper" v-if="banner_list.length > 0">
        <swiper :options="swiperOptions" ref="mySwiper">
          <!-- Slides -->
          <swiper-slide
            v-for="(item, index) in banner_list"
            :key="`banner-${index}`"
          >
            <img
              :src="item.image | default_img(false)"
              class="swiper-img"
              @click="onBannerClick(item)"
            />
          </swiper-slide>
        </swiper>
      </div>
      <!-- 新品 -->
      <div class="new-goods">
        <div class="part-title">
          <div class="title-left">
            <div class="title-en">NEW PRODUCT</div>
            <div class="title-cn">
              新品发布<span>/ 探索设计师们的最新创作</span>
            </div>
          </div>
          <div class="title-right" @click="$router.push({name:'GoodsList'})">
            选购新品
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <div class="new-goods-list">
          <div class="page-container">
            <div class="prev" @click.stop="onPageClick('prev')">
              <Icon type="ios-arrow-back" size="22" />
            </div>
            <div class="next" @click.stop="onPageClick('next')">
              <Icon type="ios-arrow-forward" size="22" />
            </div>
          </div>
          <div class="new-goods-item" v-for="(item,index) in product_list" :key="index" @click="$router.push({name:'GoodsDetail',params:{uuid:item.uuid}})">
            <div class="new-goods-cover">
              <img :src="item.image | default_img(false)" alt="" class="" />
              <div class="collect-btn" @click.stop="onCollectProduct(item.uuid,index)">
                  <img src="@/assets/images/icon-mall-collect.png" alt="" class="collect-icon">
                  {{ item.is_collected ? '已收藏':'收藏' }}
              </div>
            </div>
            <div class="new-goods-title" :title="item.name">{{item.name}}</div>
            <div class="new-goods-price">{{onPriceCalc(item)}}</div>
            <div class="new-goods-author">
              <img :src="(item.shop.logo || item.member.avatar) | default_img(false)" alt="" class="avatar" />
              <div class="nickname">{{item.shop.shop_name || item.member.nickname}}</div>
              <div class="line">|</div>
              <div class="count-num">作品:{{item.member.works}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 精选分类 -->
      <div class="recommend-cate">
        <div class="recommend-title">精选分类</div>
        <div class="recommend-desc">
          浏览我们精心策划的服装分类,找到适合您风格的完美单品
        </div>
        <div class="recommend-cate-list">
          <div
            class="recommend-cate-item"
            v-for="(item, index) in recommend_cate_list"
            :key="index"
            @mouseenter="item.hover = true"
            @mouseleave="item.hover = false" @click="$router.push({name:'GoodsList',query:{cate_id:item.product_category_id}})"
          >
            <div class="cate-item-container">
              <img
                :src="
                  (item.hover ? item.icon_active : item.icon_normal) | default_img(false)
                "
                alt=""
                class="cate-icon"
              />
              <div class="cate-name-box">
                <div class="name-cn">{{item.category_name_cn}}</div>
                <div class="name-en">{{item.category_name_en}}</div>
              </div>
            </div>
          </div>
          <div
            class="recommend-cate-item"
            @mouseenter="more_cate_hover = true"
            @mouseleave="more_cate_hover = false"
            @click="$router.push({name:'GoodsList'})"
          >
            <div class="cate-item-container">
              <img
                :src="
                  (more_cate_hover
                    ? require('@/assets/images/icon-mall-more-cate-active.png')
                    : require('@/assets/images/icon-mall-more-cate.png'))
                    | default_img(false)
                "
                alt=""
                class="cate-icon"
              />
              <div class="cate-name-box">
                <div class="name-cn">更多分类</div>
                <div class="name-en">More Categories</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 明星设计师 -->
      <div class="star-designer">
        <div class="star-part-title">
          <div class="star-title-left">
            <div class="star-title-en">STAR DESIGNER</div>
            <div class="star-title-cn">
              明星设计师<span
                >/ 探索才华横溢的设计师们,了解他们的创作理念与独特风格</span
              >
            </div>
          </div>
          <div class="star-title-right" @click="$router.push({name:'DesignerList'})">
            全部设计师
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <div class="designer-list">
          <div class="designer-item" v-for="(item,index) in designer_list" :key="index" @click="$router.push({name:'ShopHome',query:{uid:item.code}})">
            <div class="designer-info">
              <img
                :src="
                  item.avatar | default_img
                "
                alt=""
                class="designer-cover"
              />
              <div class="designer-info-content">
                <div class="designer-name-box">
                  <div class="designer-name">{{item.nickname || '-'}}</div>
                  <div @click.stop="onShopCollect(item)" class="follow-btn">{{ item.is_collect ? '已关注' :'关注' }}</div>
                </div>
                <div v-if="item.job" class="designer-job-tags">{{item.job}}</div>
                <div  class="designer-desc">
                  {{ item.designer_introduction  || item.introduction ||''}}
                </div>
                <div class="designer-count-box">
                  <div class="count-item">
                    <div class="count-num">{{item.fans_count || 0}}</div>
                    <div class="count-name">粉丝</div>
                  </div>
                  <div class="line-item"></div>
                  <div class="count-item">
                    <div class="count-num">{{item.works || 0}}</div>
                    <div class="count-name">作品</div>
                  </div>
                  <div class="line-item"></div>
                  <div class="count-item">
                    <div class="count-num">{{item.zan_count || 0}}</div>
                    <div class="count-name">获赞</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="designer-product-list">
              <div class="designer-product-item" v-for="(product,pi) in item.product" :key="pi" @click.stop="$router.push({name:'GoodsDetail',params:{uuid:product.uuid}})">
                <img :src="product.image | default_img" alt="" class="product-cover" />
                <div class="product-name">
                  {{product.name}}
                </div>
                <div class="product-price">{{onPriceCalc(product)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="designer-view-more-btn" @click="$router.push({name:'DesignerList'})">查看更多设计师</div>
      </div>
      <!-- 销售渠道介绍 -->
      <div class="sale-channel">
        <div class="channel-title">多元化推广销售渠道合作</div>
        <div class="channel-desc">
          全方位的推广与销售渠道,与我们携手,共享设计师款式红利,实现销售业绩新突破
        </div>
        <img v-if="false" src="@/assets/images/bg-mall-sale.png" alt="" class="kol-part">   
        <div class="sale-channel-list">
          <div class="sale-list-items" v-for="(item,index) in sale_channel" :key="index">
            <div class="items-container">
              <div class="icon-box">
                <img :src="item.icon" alt="" class="icons" />
              </div>
              <div class="channel-name">{{item.title}}</div>
              <div class="sale-channel-desc">
                {{item.desc}}
              </div>
            </div>
          </div>
        </div> 
      </div>
      <!-- 达人入驻 -->
      <div class="kol-join">
        <div class="title">成为我们的带货达人</div>
        <p>无需囤货压资金,你只需凭借资深销售能力与渠道,将平台优质款式推向市场~</p>
        <p>现在入驻,抢占时尚商机!即刻加入,与我们携手共享设计师款式红利,实现销售业绩新突破!</p>
        <div v-if="false" class="join-btn" @click="$router.push({name:'Login'})">立即申请入驻</div>
      </div>
    </div>
     <!-- 组件引入 -->
     <mall-side @show-chat="$refs.chat.showChat()"></mall-side>
  </div>
</template>
<script>
import {
  AddBannerStat,
  designerList,
  GetBannerList,
  getMallProductList,
  indexCate,
  MallShopCollect,
  productCollect
} from '@/api/index';
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from 'vuex';
import MallSide from "./components/MallSide";
export default {
  data() {
    return {
      banner_list: [],
      swiperOptions: {
        // 核心配置
        slidesPerView: 1, // 每页显示 1.5 张幻灯片（中间完整显示，前后各显示半张）
        centeredSlides: true, // 当前幻灯片居中显示
        spaceBetween: 20, // 幻灯片间距
        loop: true, // 启用循环模式
        loopedSlides: 2,
        grabCursor: true, // 拖动时显示抓手光标
        effect: "fade",
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 手动滑动后继续自动播放
        },
        on: {
            slideChange: this.onSlideChange, // 轮播图切换时的回调
            init: this.onSwiperInit, // 轮播图初始化时的回调
        },
      },
      more_cate_hover: false,
      recommend_cate_list: [],
      sale_channel:[
        {icon:require("@/assets/images/icon-mall-world.png"),title:'跨境电商',desc:'对接全球主流电商平台，提供一站式跨境销售解决方案，助力设计师品牌走向国际市场。'},
        {icon:require("@/assets/images/icon-mall-private.png"),title:'私域营销',desc:'建立品牌专属社群，通过精细化运营提升用户粘性与复购率，打造忠实客户群体。'},
        {icon:require("@/assets/images/icon-mall-store.png"),title:'线下门店',desc:'打造城市线下实体体验店与快闪店，提供线下试穿与沉浸式品牌体验。'},
        {icon:require("@/assets/images/icon-mall-sale-net.png"),title:'电商销售',desc:'入驻主流电商平台，结合平台流量与自有商城，实现多平台协同销售。'}
      ],
      query_form:{
        page:1,
        size:5,
        sort_field:'update_time',
        sort_order:'desc'
      },
      product_list:[],
      product_count:0,
      designer_list:[],
      currentBannerIndex: 0, // 当前轮播图索引
      exposedBanners: new Set(), // 已曝光的banner ID集合
    };
  },
  components: {
    swiper,
    swiperSlide,MallSide
  },
  computed:{
    ...mapState({
      is_login:state=>state.is_login
    })
  },
  mounted() {
    Promise.all([
      this.onGetBannlerList(),
      this.onGetDesignerList(),
      this.onGetIndexCate(),
      this.onGetProductList()
    ])
    // this.recommend_cate_list = this.recommend_cate_list.map((item)=>{
    //   return {...item,hover:false}
    // })
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "mall");
    });
  },
  methods: {
    onPriceCalc(product){
      // console.log('product-price-calc',product);
      const {price_mode,price_step,tag_price} = product;
      if(price_mode == 1){
        return `¥${tag_price || '0'}`;
      }
      let min_price = '0',max_price = '0'
      if(price_step && price_step.length > 0){
        min_price = Math.min(...price_step.map(item=>Number(item.price)));
        max_price = Math.max(...price_step.map(item=>Number(item.price)));
      }
      return `¥${min_price}~${max_price}`;
    },
    async onShopCollect({id}){
        try{
            const {code,msg} = await MallShopCollect({shop_id:id});
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.onGetDesignerList();
        }catch(e){
            console.log('err-shop-collect',e);
        }
    },
    onBannerClick(data) {
      // 记录点击统计
      this.recordBannerClick(data);
      if (!data.url) return;
      if (data.url.includes("http")) {
        window.location.href = data.url;
      } else {
        this.$router.push(data.url);
      }
    },
    async onGetBannlerList(){
      try{
        const {code,msg,data} = await GetBannerList({position:8});
        if(code > 0){
          this.$layer.msg(msg);
          return;
        }
        console.log('data-banner-list',data);
        this.banner_list = data;
      }catch(e){
        console.log('err-banner-list',e);
      }
    },
    async onGetDesignerList(){
      try{
        const {code,msg,data} = await designerList({page:1,limit:10,is_recommend:1});
        if(code>1){
          this.$layer.msg(msg);
          return;
        }
        this.designer_list = data.list;
        console.log('data->designer',data);
      }catch(e){
        console.log('err-designer-list',e);
      }
    },
    onPageClick(type){
      const {page,size} = this.query_form;
      switch(type){
        case 'prev':
          if(page == 1){
            this.$layer.msg('没有更多了~');
            return;
          }
          this.query_form.page--;
          break;
        case 'next':
          if(Number(page)*Number(size) >= this.product_count || this.product_list.length < size){
            this.$layer.msg('没有更多了~');
            return;
          }
          this.query_form.page++;
          break;
      }
      this.onGetProductList();
    },
    async onCollectProduct(uuid,index){
      try{
        const {code,msg} = await productCollect({uuid});
        if(code > 0){
          this.$layer.msg(msg);
          return;
        }
        this.product_list[index].is_collected = !this.product_list[index].is_collected;
        this.$layer.msg('操作成功~');
      }catch(e){
        console.log('err-collect',e);
      }
    },
    async onGetProductList(){
      try{
        const {data} = await getMallProductList(this.query_form)
        console.log('data-product-list',data);
        this.product_count = data.count;
        this.product_list = data.list;
        console.log('product-list',this.product_list);
      }catch(e){
        console.log('err->product-list',e);
      }
    },
    async onGetIndexCate(){
      try{
        const {data} = await indexCate();
        console.log('data',data);
        this.recommend_cate_list = data.map(item=>{
          return {...item,hover:false,icon_active:item.mall_icon['active'],icon_normal:item.mall_icon['normal']}
        })
      }catch(e){
        console.log('err=>',e);
      }
    },
    // 轮播图初始化回调
    onSwiperInit() {
      // 初始化时记录第一张轮播图的曝光
      this.recordBannerExposure(0);
    },
    // 轮播图切换回调
    onSlideChange() {
      const swiper = this.$refs.mySwiper;
      if (swiper && swiper.swiper) {
        const activeIndex = swiper.swiper.realIndex; // 获取真实索引（考虑循环模式）
        this.currentBannerIndex = activeIndex;
        // 记录当前轮播图的曝光
        this.recordBannerExposure(activeIndex);
      }
    },
    // 记录轮播图曝光
    async recordBannerExposure(index) {
      try {
        const banner = this.banner_list[index];
        if (banner && banner.id) {
          // 检查该banner是否已经统计过曝光
          if (this.exposedBanners.has(banner.id)) {
            return;
          }
          // 记录该banner已曝光
          this.exposedBanners.add(banner.id);
          // 调用接口统计曝光
          await AddBannerStat({
            banner_id: banner.id,
            stat_type: 2, // 2表示曝光
            user_id: this.$store.state.userInfo.id || 0
          });
        }
      } catch (e) {
        console.log('曝光统计失败', e);
      }
    },
    // 记录轮播图点击
    async recordBannerClick(banner) {
      try {
        if (banner && banner.id) {
          await AddBannerStat({
            banner_id: banner.id,
            stat_type: 1, // 1表示点击
            user_id: this.$store.state.userInfo.id || 0
          });
        }
      } catch (e) {
        console.log('点击统计失败', e);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.mall-index {
  width: 100%;
  // min-height:auto;
  // height:100%;
  min-height: calc(100vh - 500px);

  --scale-ratio:1;

  // padding-bottom: 500px;  // 根据 footer 高度调整
  box-sizing: border-box;

  .scale-container{
    width:100%;
    transform-origin:top left;
    transform:scale(var(--scale-ratio));
    // height: calc(100vh / var(--scale-ratio));
  }
  // padding-bottom: 20%;

  // 顶部轮播开始
  .mall-swiper {
    width: 100%;
    height: 580px;

    .swiper-container {
      position: relative;
      /* 确保按钮定位参考容器 */
      width: 100%;
      height: 100%;
      overflow: visible;
      display: flex;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background: #fff;
    }

    .swiper-img {
      width: 100%;
      height: 100%;
      // object-fit: none;
      object-position: center;
    }
  }

  // 新品推荐开始
  .new-goods {
    padding: 0 100px;
    margin-top: 40px;
    width: 100%;

    .part-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .title-left {
        display: flex;
        flex-direction: column;

        // row-gap:9px;
        .title-en {
          color: rgba(51, 51, 51, 0.1);
          font-size: 52px;
          font-weight: bold;
          line-height: 1;
        }

        .title-cn {
          display: flex;
          align-items: flex-end;
          color: #333333;
          font-size: 32px;
          font-weight: bold;
          line-height: 1;

          span {
            color: rgba(102, 102, 102, 0.6);
            font-size: 16px;
            margin-left: 10px;
          }
        }
      }

      .title-right {
        color: #666666;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }

    .new-goods-list {
      width: 100%;
      margin-top: 34px;
      display: flex;
      column-gap: 35px;
      // justify-content: space-between;
      position: relative;

      .new-goods-item {
        width: calc(100% / 5 - 25px);
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: start;

        .new-goods-cover {
          width: 100%;
          height:430px;
          border-radius: 6px;
          background: #f5f5f5;
          overflow: hidden;
          position: relative;
          // aspect-ratio:16/9;
          display:flex;
          align-items:center;
          justify-content:center;

          img {
            width: 100%;
            // height: 100%;
            height:auto;
            display:block;
            max-height:430px;
            border-radius: 6px;
            object-fit: cover;
          }

          .collect-btn {
            display: none;
            position: absolute;
            right: 20px;
            bottom: 20px;
            background: rgba(255, 255, 255, 0.7);
            border-radius: 16px;
            color: #4d4d4d;
            font-size: 12px;
            
            padding: 6px 10px;
            cursor: pointer;

            .collect-icon {
              width: 20px;
              height: 20px;
              margin-right: 4px;
            }
          }

          &:hover {
            .collect-btn {
              display: flex;
              align-items: center;
            }
          }
        }

        .new-goods-title {
          // margin-top:20px;
          line-height: 35.81px;
          color: #1a1a1a;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width:100%;
        }

        .new-goods-price {
          line-height: 35.81px;
          color: #1a1a1a;
          font-size: 18px;
          font-weight: bold;
        }

        .new-goods-author {
          display: flex;
          align-items: center;
          width: 100%;

          // margin-top:19px;
          .avatar {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            margin-right: 9px;
          }

          .line {
            margin: 0 9px;
            font-size: 13px;
          }

          .nickname,
          .count-num {
            flex: 0 0 1;
            color: #666666;
            font-size: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .page-container {
        position: absolute;
        top: 203px;
        z-index: 10;
        width: 100%;
        display: flex;
        justify-content: space-between;
        pointer-events:none;

        .prev,
        .next {
          width: 40px;
          height: 44px;
          background: rgba(255, 255, 255, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          pointer-events:auto;
        }
      }
    }
  }

  // 新品推荐结束
  // 精选分类开始
  .recommend-cate {
    width: 100%;
    height: auto;
    max-height: 410px;
    margin-top: 67px;
    background-image: url("../../assets/images/bg-mall-recommend-cate.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:0 3%;

    .recommend-title {
      color: #ffffff;
      font-weight: bold;
      font-size: 32px;
      margin-top: 66px;
    }

    .recommend-desc {
      margin-top: 24px;
      color: #ffffff;
      font-size: 16px;
    }

    .recommend-cate-list {
      display: flex;
      justify-content:center;
      width:100%;
      column-gap: 19px;
      margin-top: 62px;
      padding-bottom: 86px;
      margin-bottom:10px;
      overflow-x:auto;
      overflow-y:hidden;
      &::-webkit-scrollbar{
        background:rgba(255,255,255,0.5);
        border-radius:10px;
        height:8px;
      }
      &::-webkit-scrollbar-track{
        // background:transparent !important;
        border-radius:6px;
      }
      &::-webkit-scrollbar-thumb{
        // background:transparent;
        background:rgba(255,255,255,0.8);
        border-radius:6px !important;
      }

      .recommend-cate-item {
        flex: 0 0 11.53%;
        height: 126px;
        background: #ffffff;
        border-radius: 6px;
        cursor: pointer;

        &:hover {
          .cate-item-container > .cate-name-box > .name-cn {
            color: #ff5967;
          }
        }

        .cate-item-container {
          width: 100%;
          height: 100%;
          padding: 0 10px;
          display: flex;
          align-items: center;
          column-gap: 9px;

          .cate-icon {
            width: 56px;
            height: 68px;
            object-fit: cover;
          }

          .cate-name-box {
            display: flex;
            flex-direction: column;

            .name-cn {
              color: #1a1a1a;
              font-size: 18px;
              white-space: nowrap;
            }

            .name-en {
              color: #808080;
              font-size: 12px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  // 精选分类结束
  // 明星设计师开始
  .star-designer {
    width: 100%;
    padding: 0 5%;
    margin-top: 58px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .star-part-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .star-title-left {
        display: flex;
        flex-direction: column;

        // row-gap:9px;
        .star-title-en {
          color: rgba(51, 51, 51, 0.1);
          font-size: 52px;
          font-weight: bold;
          line-height: 1;
        }

        .star-title-cn {
          display: flex;
          align-items: flex-end;
          color: #333333;
          font-size: 32px;
          font-weight: bold;
          line-height: 1;

          span {
            color: rgba(102, 102, 102, 0.6);
            font-size: 16px;
            margin-left: 10px;
          }
        }
      }

      .star-title-right {
        color: #666666;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }

    .designer-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 38px;
      row-gap: 16px;

      .designer-item {
        width: 100%;
        background: #f5f5f5;
        padding: 25px 20px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        column-gap: 30px;

        &:hover {
          background: #ffffff;
          box-shadow: 0px 0px 13px 0px #e0e0e0;
        }

        .designer-info {
          display: flex;
          align-items: center;
          column-gap: 24px;

          .designer-cover {
            width: 250px;
            height: 314px;
            border-radius: 10px;
            object-fit: cover;
            object-position: center;
          }

          .designer-info-content {
            display: flex;
            flex-direction: column;
            // align-items:center;
            justify-content: space-between;
            width: 320px;
            height:314px;
            // width: 100%;
            overflow:auto;
            flex-shrink:0;

            .designer-name-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;

              .designer-name {
                color: #1a1a1a;
                font-size: 24px;
                font-weight: bold;
                flex:1;
                white-space:nowrap;
                text-overflow: ellipsis;
                overflow:hidden;
              }

              .follow-btn {
                color: #ff5067;
                border: 1px solid #ff5967;
                border-radius: 8px;
                padding: 6px 15px;
                cursor: pointer;
                flex-shrink:0;
              }
            }

            .designer-job-tags {
              color: #666666;
              font-size: 14px;
              line-height: 36px;
            }

            .designer-desc {
              color: #1a1a1a;
              font-size: 14px;
              margin-top: 19px;
              line-height: 24px;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .designer-count-box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 63px;

              .count-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .count-num {
                  color: #ff5967;
                  font-size: 22px;
                  font-weight: bold;
                }

                .count-name {
                  color: #666666;
                  font-size: 14px;
                }
              }

              .line-item {
                width: 1px;
                height: 54px;
                background: #ebebeb;
              }
            }
          }
        }

        .designer-product-list {
          display: flex;
          align-items: center;
          column-gap: 10px;
          flex:1;
          flex-shrink:0;
          overflow-x:hidden;
          overflow-y: visible;

          .designer-product-item {
            display: flex;
            flex-direction: column;
            // width: 200px;
            width:calc(100% / 5 - 10px);
            max-width:200px;

            .product-cover {
              width: 100%;
              height: 260px;
              border-radius: 6px;
              background: #f5f5f5;
              border: 1px solid #e0e0e0;
              object-fit:contain;
            }

            .product-name {
              color: #333333;
              font-size: 14px;
              line-height: 35px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .product-price {
              color: #333333;
              font-size: 16px;
              font-weight: bold;
              // line-height: 16px; //>导致Mac下出现Y轴滚动
            }
          }
        }
      }
    }

    .designer-view-more-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      border: 1px solid #333333;
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.5);
      font-size: 16px;
      line-height: 36px;
      margin-top: 50px;
      color: #333333;
      cursor: pointer;
    }
  }

  // 明星设计师结束
  // 合作渠道开始
  .sale-channel {
    width: 100%;
    background: #f5f5f5;
    padding: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 65px;

    .channel-title {
      color: #000000;
      font-size: 32px;
      font-weight: bold;
      padding-top: 64px;
      // line-height:36px;
    }

    .channel-desc {
      color: #000000;
      font-size: 16px;
      line-height: 36px;
    }
    .kol-part{
      width:100%;
      height:339px;
      object-fit:contain;
      margin-top:53px;
    }
    .sale-channel-list{
      width:100%;
      display:flex;
      align-items:center;
      justify-content: space-between;
      margin-top:87px;
      column-gap:20px;
      padding-bottom:66px;
      .sale-list-items{
        width:calc((90% - 20px) / 4);
        background:#ffffff;
        border-radius:20px;
        box-shadow:0px 0px 16px 0px #e0e0e0;
        .items-container{
          padding:0 35px;
          display:flex;
          flex-direction:column;
          align-items:center;
          .icon-box{
            display:flex;
            align-items:center;
            justify-content:center;
            border-radius:50%;
            background:#f7f7f7;
            width:110px;
            height:110px;
            margin-top:30px;
            .icons{
              width:50px;
              height:50px;
            }
          }
          .channel-name{
            color:#1a1a1a;
            font-weight:bold;
            font-size:26px;
            position:relative;
            margin:28px;
            // padding-bottom:28px;
            &::after{ 
              content:'';
              position:absolute;
              width:42px;
              height:4px;
              background:#ff5967;
              left:50%;
              top:40px;
              transform:translateX(-50%);
            }
          }
          .sale-channel-desc{
            color:#666666;
            font-size:16px;
            display:-webkit-box;
            -webkit-line-clamp:2;
            -webkit-box-orient:vertical;
            overflow:hidden;
            text-overflow:ellipsis;
            padding-bottom:39px;
          }
        }
      }
    }
  }
  // 合作渠道结束
  // 达人入驻
  .kol-join{
    width:100%;
    height:420px;
    background-image:url('../../assets/images/bg-mall-join.png');
    background-repeat: no-repeat;
    background-size:cover;
    background-position:center;
    display:flex;
    // justify-content:center;
    flex-direction:column;
    align-items:center;
    .title{
      color:#000000;
      font-size:36px;
      font-weight:bold;
      margin-top:77px;
      line-height:36px;
      margin-bottom:38px;
    }
    p{
      color:#333333;
      font-size:20px;
      line-height:38px;
    }
    .join-btn{
      margin-top:57px;
      width:237px;
      height:60px;
      background:#ff5967;
      color:#ffffff;
      border-radius:30px;
      text-align:center;
      line-height:60px;
      cursor:pointer;
      font-size:16px;
      font-weight:500;
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .mall-index {
    --scale-ratio: 0.8;
    
    // 补偿缩放后的空间，避免留白
    // padding-bottom: calc(20% / 0.8);
    // padding-bottom: calc(100px / 0.8);
    // padding-bottom: calc(500px / var(--scale-ratio)); 
    .scale-container {
      // 反向缩放宽度，保持占满屏幕
      width: calc(100% / 0.8);
      // height: calc(100% / var(--scale-ratio));
    }
  }
}

// 小屏幕 (max-width: 1279px) - 缩放比例 0.6
@media screen and (max-width: 1279px) {
  .mall-index {
    --scale-ratio: 0.6;
    
    // 补偿缩放后的空间
    // padding-bottom: calc(20% / 0.6);
    // padding-bottom: calc(100px / 0.6);
    // padding-bottom: calc(500px / var(--scale-ratio)); 
    .scale-container {
      width: calc(100% / 0.6);
      // height: calc(100vh / var(--scale-ratio));
    }
  }
}

// @media screen and (min-width: 1280px) and (max-width: 1679px) {
//   .mall-index {
//     // 顶部轮播
//     .mall-swiper {
//       height: 464px; // 580 * 0.8
      
//       .swiper-img {
//         object-position: center;
//       }
//     }

//     // 新品推荐
//     .new-goods {
//       padding: 0 80px; // 100 * 0.8
//       margin-top: 32px; // 40 * 0.8
      
//       .part-title {
//         .title-left {
//           .title-en {
//             font-size: 41.6px; // 52 * 0.8
//           }
          
//           .title-cn {
//             font-size: 25.6px; // 32 * 0.8
            
//             span {
//               font-size: 12.8px; // 16 * 0.8
//               margin-left: 8px; // 10 * 0.8
//             }
//           }
//         }
        
//         .title-right {
//           font-size: 12.8px; // 16 * 0.8
//         }
//       }
      
//       .new-goods-list {
//         margin-top: 27.2px; // 34 * 0.8
//         column-gap: 20px; // 25 * 0.8
        
//         .new-goods-item {
//           width: calc(100% / 5 - 20px); // 25 * 0.8
          
//           .new-goods-cover {
//             max-height: 344px; // 430 * 0.8
//             border-radius: 4.8px; // 6 * 0.8
            
//             img {
//               max-height: 344px; // 430 * 0.8
//               border-radius: 4.8px; // 6 * 0.8
//             }
            
//             &:hover {
//               .collect-btn {
//                 right: 16px; // 20 * 0.8
//                 bottom: 16px; // 20 * 0.8
//                 border-radius: 12.8px; // 16 * 0.8
//                 font-size: 9.6px; // 12 * 0.8
//                 padding: 4.8px 8px; // 6*0.8, 10*0.8
                
//                 .collect-icon {
//                   width: 16px; // 20 * 0.8
//                   height: 16px; // 20 * 0.8
//                   margin-right: 3.2px; // 4 * 0.8
//                 }
//               }
//             }
//           }
          
//           .new-goods-title {
//             line-height: 28.65px; // 35.81 * 0.8
//             font-size: 12.8px; // 16 * 0.8
//           }
          
//           .new-goods-price {
//             line-height: 28.65px; // 35.81 * 0.8
//             font-size: 14.4px; // 18 * 0.8
//           }
          
//           .new-goods-author {
//             .avatar {
//               width: 20px; // 25 * 0.8
//               height: 20px; // 25 * 0.8
//               margin-right: 7.2px; // 9 * 0.8
//             }
            
//             .line {
//               margin: 0 7.2px; // 9 * 0.8
//               font-size: 10.4px; // 13 * 0.8
//             }
            
//             .nickname,
//             .count-num {
//               font-size: 10.4px; // 13 * 0.8
//             }
//           }
//         }
        
//         .page-container {
//           top: 162.4px; // 203 * 0.8
          
//           .prev,
//           .next {
//             width: 32px; // 40 * 0.8
//             height: 35.2px; // 44 * 0.8
//           }
//         }
//       }
//     }
    
//     // 精选分类
//     .recommend-cate {
//       max-height: 328px; // 410 * 0.8
//       margin-top: 53.6px; // 67 * 0.8
//       padding: 0 3%;
      
//       .recommend-title {
//         font-size: 25.6px; // 32 * 0.8
//         margin-top: 52.8px; // 66 * 0.8
//       }
      
//       .recommend-desc {
//         margin-top: 19.2px; // 24 * 0.8
//         font-size: 12.8px; // 16 * 0.8
//       }
      
//       .recommend-cate-list {
//         column-gap: 15.2px; // 19 * 0.8
//         margin-top: 49.6px; // 62 * 0.8
//         padding-bottom: 68.8px; // 86 * 0.8
//         margin-bottom: 8px; // 10 * 0.8
        
//         &::-webkit-scrollbar {
//           border-radius: 8px; // 10 * 0.8
//           height: 6.4px; // 8 * 0.8
//         }
        
//         &::-webkit-scrollbar-thumb {
//           border-radius: 4.8px !important; // 6 * 0.8
//         }
        
//         .recommend-cate-item {
//           height: 100.8px; // 126 * 0.8
//           border-radius: 4.8px; // 6 * 0.8
          
//           .cate-item-container {
//             padding: 0 8px; // 10 * 0.8
//             column-gap: 7.2px; // 9 * 0.8
            
//             .cate-icon {
//               width: 44.8px; // 56 * 0.8
//               height: 54.4px; // 68 * 0.8
//             }
            
//             .cate-name-box {
//               .name-cn {
//                 font-size: 14.4px; // 18 * 0.8
//               }
              
//               .name-en {
//                 font-size: 9.6px; // 12 * 0.8
//               }
//             }
//           }
//         }
//       }
//     }
    
//     // 明星设计师
//     .star-designer {
//       padding: 0 5%;
//       margin-top: 46.4px; // 58 * 0.8
      
//       .star-part-title {
//         .star-title-left {
//           .star-title-en {
//             font-size: 41.6px; // 52 * 0.8
//           }
          
//           .star-title-cn {
//             font-size: 25.6px; // 32 * 0.8
            
//             span {
//               font-size: 12.8px; // 16 * 0.8
//               margin-left: 8px; // 10 * 0.8
//             }
//           }
//         }
        
//         .star-title-right {
//           font-size: 12.8px; // 16 * 0.8
//         }
//       }
      
//       .designer-list {
//         margin-top: 30.4px; // 38 * 0.8
//         row-gap: 12.8px; // 16 * 0.8
        
//         .designer-item {
//           padding: 20px 16px; // 25*0.8, 20*0.8
//           border-radius: 4.8px; // 6 * 0.8
//           column-gap: 24px; // 30 * 0.8
          
//           .designer-info {
//             column-gap: 19.2px; // 24 * 0.8
            
//             .designer-cover {
//               width: 200px; // 250 * 0.8
//               height: 251.2px; // 314 * 0.8
//               border-radius: 8px; // 10 * 0.8
//             }
            
//             .designer-info-content {
//               max-width: 256px; // 320 * 0.8
              
//               .designer-name-box {
//                 .designer-name {
//                   font-size: 19.2px; // 24 * 0.8
//                 }
                
//                 .follow-btn {
//                   border-radius: 6.4px; // 8 * 0.8
//                   padding: 4.8px 12px; // 6*0.8, 15*0.8
//                 }
//               }
              
//               .designer-job-tags {
//                 font-size: 11.2px; // 14 * 0.8
//                 line-height: 28.8px; // 36 * 0.8
//               }
              
//               .designer-desc {
//                 font-size: 11.2px; // 14 * 0.8
//                 margin-top: 15.2px; // 19 * 0.8
//                 line-height: 19.2px; // 24 * 0.8
//               }
              
//               .designer-count-box {
//                 margin-top: 50.4px; // 63 * 0.8
                
//                 .count-item {
//                   .count-num {
//                     font-size: 17.6px; // 22 * 0.8
//                   }
                  
//                   .count-name {
//                     font-size: 11.2px; // 14 * 0.8
//                   }
//                 }
                
//                 .line-item {
//                   height: 43.2px; // 54 * 0.8
//                 }
//               }
//             }
//           }
          
//           .designer-product-list {
//             column-gap: 8px; // 10 * 0.8
            
//             .designer-product-item {
//               .product-cover {
//                 height: 208px; // 260 * 0.8
//                 border-radius: 4.8px; // 6 * 0.8
//               }
              
//               .product-name {
//                 font-size: 11.2px; // 14 * 0.8
//                 line-height: 28px; // 35 * 0.8
//               }
              
//               .product-price {
//                 font-size: 12.8px; // 16 * 0.8
//               }
//             }
//           }
//         }
//       }
      
//       .designer-view-more-btn {
//         width: 160px; // 200 * 0.8
//         border-radius: 4.8px; // 6 * 0.8
//         font-size: 12.8px; // 16 * 0.8
//         line-height: 28.8px; // 36 * 0.8
//         margin-top: 40px; // 50 * 0.8
//       }
//     }
    
//     // 合作渠道
//     .sale-channel {
//       margin-top: 52px; // 65 * 0.8
      
//       .channel-title {
//         font-size: 25.6px; // 32 * 0.8
//         padding-top: 51.2px; // 64 * 0.8
//       }
      
//       .channel-desc {
//         font-size: 12.8px; // 16 * 0.8
//         line-height: 28.8px; // 36 * 0.8
//       }
      
//       .kol-part {
//         height: 271.2px; // 339 * 0.8
//         margin-top: 42.4px; // 53 * 0.8
//       }
      
//       .sale-channel-list {
//         margin-top: 69.6px; // 87 * 0.8
//         column-gap: 16px; // 20 * 0.8
//         padding-bottom: 52.8px; // 66 * 0.8
        
//         .sale-list-items {
//           border-radius: 16px; // 20 * 0.8
          
//           .items-container {
//             padding: 0 28px; // 35 * 0.8
            
//             .icon-box {
//               border-radius: 50%;
//               width: 88px; // 110 * 0.8
//               height: 88px; // 110 * 0.8
//               margin-top: 24px; // 30 * 0.8
              
//               .icons {
//                 width: 40px; // 50 * 0.8
//                 height: 40px; // 50 * 0.8
//               }
//             }
            
//             .channel-name {
//               font-size: 20.8px; // 26 * 0.8
//               margin: 22.4px; // 28 * 0.8
              
//               &::after {
//                 width: 33.6px; // 42 * 0.8
//                 height: 3.2px; // 4 * 0.8
//                 top: 32px; // 40 * 0.8
//               }
//             }
            
//             .sale-channel-desc {
//               font-size: 12.8px; // 16 * 0.8
//               padding-bottom: 31.2px; // 39 * 0.8
//             }
//           }
//         }
//       }
//     }
    
//     // 达人入驻
//     .kol-join {
//       height: 336px; // 420 * 0.8
      
//       .title {
//         font-size: 28.8px; // 36 * 0.8
//         margin-top: 61.6px; // 77 * 0.8
//         line-height: 28.8px; // 36 * 0.8
//         margin-bottom: 30.4px; // 38 * 0.8
//       }
      
//       p {
//         font-size: 16px; // 20 * 0.8
//         line-height: 30.4px; // 38 * 0.8
//       }
      
//       .join-btn {
//         margin-top: 45.6px; // 57 * 0.8
//         width: 189.6px; // 237 * 0.8
//         height: 48px; // 60 * 0.8
//         border-radius: 24px; // 30 * 0.8
//         line-height: 48px; // 60 * 0.8
//         font-size: 12.8px; // 16 * 0.8
//       }
//     }
//   }
// }

// @media screen and (max-width: 1279px) {
//   .mall-index {
//     // 顶部轮播
//     .mall-swiper {
//       height: 348px; // 580 * 0.6
      
//       .swiper-img {
//         object-position: center;
//       }
//     }

//     // 新品推荐
//     .new-goods {
//       padding: 0 60px; // 100 * 0.6
//       margin-top: 24px; // 40 * 0.6
      
//       .part-title {
//         .title-left {
//           .title-en {
//             font-size: 31.2px; // 52 * 0.6
//           }
          
//           .title-cn {
//             font-size: 19.2px; // 32 * 0.6
            
//             span {
//               font-size: 9.6px; // 16 * 0.6
//               margin-left: 6px; // 10 * 0.6
//             }
//           }
//         }
        
//         .title-right {
//           font-size: 9.6px; // 16 * 0.6
//         }
//       }
      
//       .new-goods-list {
//         margin-top: 20.4px; // 34 * 0.6
//         column-gap: 15px; // 25 * 0.6
        
//         .new-goods-item {
//           width: calc(100% / 5 - 15px); // 25 * 0.6
          
//           .new-goods-cover {
//             max-height: 258px; // 430 * 0.6
//             border-radius: 3.6px; // 6 * 0.6
            
//             img {
//               max-height: 258px; // 430 * 0.6
//               border-radius: 3.6px; // 6 * 0.6
//             }
            
//             &:hover {
//               .collect-btn {
//                 right: 12px; // 20 * 0.6
//                 bottom: 12px; // 20 * 0.6
//                 border-radius: 9.6px; // 16 * 0.6
//                 font-size: 7.2px; // 12 * 0.6
//                 padding: 3.6px 6px; // 6*0.6, 10*0.6
                
//                 .collect-icon {
//                   width: 12px; // 20 * 0.6
//                   height: 12px; // 20 * 0.6
//                   margin-right: 2.4px; // 4 * 0.6
//                 }
//               }
//             }
//           }
          
//           .new-goods-title {
//             line-height: 21.49px; // 35.81 * 0.6
//             font-size: 9.6px; // 16 * 0.6
//           }
          
//           .new-goods-price {
//             line-height: 21.49px; // 35.81 * 0.6
//             font-size: 10.8px; // 18 * 0.6
//           }
          
//           .new-goods-author {
//             .avatar {
//               width: 15px; // 25 * 0.6
//               height: 15px; // 25 * 0.6
//               margin-right: 5.4px; // 9 * 0.6
//             }
            
//             .line {
//               margin: 0 5.4px; // 9 * 0.6
//               font-size: 7.8px; // 13 * 0.6
//             }
            
//             .nickname,
//             .count-num {
//               font-size: 7.8px; // 13 * 0.6
//             }
//           }
//         }
        
//         .page-container {
//           top: 121.8px; // 203 * 0.6
          
//           .prev,
//           .next {
//             width: 24px; // 40 * 0.6
//             height: 26.4px; // 44 * 0.6
//           }
//         }
//       }
//     }
    
//     // 精选分类
//     .recommend-cate {
//       max-height: 246px; // 410 * 0.6
//       margin-top: 40.2px; // 67 * 0.6
//       padding: 0 3%;
      
//       .recommend-title {
//         font-size: 19.2px; // 32 * 0.6
//         margin-top: 39.6px; // 66 * 0.6
//       }
      
//       .recommend-desc {
//         margin-top: 14.4px; // 24 * 0.6
//         font-size: 9.6px; // 16 * 0.6
//       }
      
//       .recommend-cate-list {
//         column-gap: 11.4px; // 19 * 0.6
//         margin-top: 37.2px; // 62 * 0.6
//         padding-bottom: 51.6px; // 86 * 0.6
//         margin-bottom: 6px; // 10 * 0.6
        
//         &::-webkit-scrollbar {
//           border-radius: 6px; // 10 * 0.6
//           height: 4.8px; // 8 * 0.6
//         }
        
//         &::-webkit-scrollbar-thumb {
//           border-radius: 3.6px !important; // 6 * 0.6
//         }
        
//         .recommend-cate-item {
//           height: 75.6px; // 126 * 0.6
//           border-radius: 3.6px; // 6 * 0.6
          
//           .cate-item-container {
//             padding: 0 6px; // 10 * 0.6
//             column-gap: 5.4px; // 9 * 0.6
            
//             .cate-icon {
//               width: 33.6px; // 56 * 0.6
//               height: 40.8px; // 68 * 0.6
//             }
            
//             .cate-name-box {
//               .name-cn {
//                 font-size: 10.8px; // 18 * 0.6
//               }
              
//               .name-en {
//                 font-size: 7.2px; // 12 * 0.6
//               }
//             }
//           }
//         }
//       }
//     }
    
//     // 明星设计师
//     .star-designer {
//       padding: 0 5%;
//       margin-top: 34.8px; // 58 * 0.6
      
//       .star-part-title {
//         .star-title-left {
//           .star-title-en {
//             font-size: 31.2px; // 52 * 0.6
//           }
          
//           .star-title-cn {
//             font-size: 19.2px; // 32 * 0.6
            
//             span {
//               font-size: 9.6px; // 16 * 0.6
//               margin-left: 6px; // 10 * 0.6
//             }
//           }
//         }
        
//         .star-title-right {
//           font-size: 9.6px; // 16 * 0.6
//         }
//       }
      
//       .designer-list {
//         margin-top: 22.8px; // 38 * 0.6
//         row-gap: 9.6px; // 16 * 0.6
        
//         .designer-item {
//           padding: 15px 12px; // 25*0.6, 20*0.6
//           border-radius: 3.6px; // 6 * 0.6
//           column-gap: 18px; // 30 * 0.6
          
//           .designer-info {
//             column-gap: 14.4px; // 24 * 0.6
            
//             .designer-cover {
//               width: 150px; // 250 * 0.6
//               height: 188.4px; // 314 * 0.6
//               border-radius: 6px; // 10 * 0.6
//             }
            
//             .designer-info-content {
//               max-width: 192px; // 320 * 0.6
              
//               .designer-name-box {
//                 .designer-name {
//                   font-size: 14.4px; // 24 * 0.6
//                 }
                
//                 .follow-btn {
//                   border-radius: 4.8px; // 8 * 0.6
//                   padding: 3.6px 9px; // 6*0.6, 15*0.6
//                 }
//               }
              
//               .designer-job-tags {
//                 font-size: 8.4px; // 14 * 0.6
//                 line-height: 21.6px; // 36 * 0.6
//               }
              
//               .designer-desc {
//                 font-size: 8.4px; // 14 * 0.6
//                 margin-top: 11.4px; // 19 * 0.6
//                 line-height: 14.4px; // 24 * 0.6
//               }
              
//               .designer-count-box {
//                 margin-top: 37.8px; // 63 * 0.6
                
//                 .count-item {
//                   .count-num {
//                     font-size: 13.2px; // 22 * 0.6
//                   }
                  
//                   .count-name {
//                     font-size: 8.4px; // 14 * 0.6
//                   }
//                 }
                
//                 .line-item {
//                   height: 32.4px; // 54 * 0.6
//                 }
//               }
//             }
//           }
          
//           .designer-product-list {
//             column-gap: 6px; // 10 * 0.6
            
//             .designer-product-item {
//               .product-cover {
//                 height: 156px; // 260 * 0.6
//                 border-radius: 3.6px; // 6 * 0.6
//               }
              
//               .product-name {
//                 font-size: 8.4px; // 14 * 0.6
//                 line-height: 21px; // 35 * 0.6
//               }
              
//               .product-price {
//                 font-size: 9.6px; // 16 * 0.6
//               }
//             }
//           }
//         }
//       }
      
//       .designer-view-more-btn {
//         width: 120px; // 200 * 0.6
//         border-radius: 3.6px; // 6 * 0.6
//         font-size: 9.6px; // 16 * 0.6
//         line-height: 21.6px; // 36 * 0.6
//         margin-top: 30px; // 50 * 0.6
//       }
//     }
    
//     // 合作渠道
//     .sale-channel {
//       margin-top: 39px; // 65 * 0.6
      
//       .channel-title {
//         font-size: 19.2px; // 32 * 0.6
//         padding-top: 38.4px; // 64 * 0.6
//       }
      
//       .channel-desc {
//         font-size: 9.6px; // 16 * 0.6
//         line-height: 21.6px; // 36 * 0.6
//       }
      
//       .kol-part {
//         height: 203.4px; // 339 * 0.6
//         margin-top: 31.8px; // 53 * 0.6
//       }
      
//       .sale-channel-list {
//         margin-top: 52.2px; // 87 * 0.6
//         column-gap: 12px; // 20 * 0.6
//         padding-bottom: 39.6px; // 66 * 0.6
        
//         .sale-list-items {
//           border-radius: 12px; // 20 * 0.6
          
//           .items-container {
//             padding: 0 21px; // 35 * 0.6
            
//             .icon-box {
//               border-radius: 50%;
//               width: 66px; // 110 * 0.6
//               height: 66px; // 110 * 0.6
//               margin-top: 18px; // 30 * 0.6
              
//               .icons {
//                 width: 30px; // 50 * 0.6
//                 height: 30px; // 50 * 0.6
//               }
//             }
            
//             .channel-name {
//               font-size: 15.6px; // 26 * 0.6
//               margin: 16.8px; // 28 * 0.6
              
//               &::after {
//                 width: 25.2px; // 42 * 0.6
//                 height: 2.4px; // 4 * 0.6
//                 top: 24px; // 40 * 0.6
//               }
//             }
            
//             .sale-channel-desc {
//               font-size: 9.6px; // 16 * 0.6
//               padding-bottom: 23.4px; // 39 * 0.6
//             }
//           }
//         }
//       }
//     }
    
//     // 达人入驻
//     .kol-join {
//       height: 252px; // 420 * 0.6
      
//       .title {
//         font-size: 21.6px; // 36 * 0.6
//         margin-top: 46.2px; // 77 * 0.6
//         line-height: 21.6px; // 36 * 0.6
//         margin-bottom: 22.8px; // 38 * 0.6
//       }
      
//       p {
//         font-size: 12px; // 20 * 0.6
//         line-height: 22.8px; // 38 * 0.6
//       }
      
//       .join-btn {
//         margin-top: 34.2px; // 57 * 0.6
//         width: 142.2px; // 237 * 0.6
//         height: 36px; // 60 * 0.6
//         border-radius: 18px; // 30 * 0.6
//         line-height: 36px; // 60 * 0.6
//         font-size: 9.6px; // 16 * 0.6
//       }
//     }
//   }
// }
</style>
